/* src/app/global/components/global-help/global-help-nav/global-help-nav.component.scss */
:host .cw-flex-row {
  flex-wrap: wrap-reverse;
}
:host .cw-flex-row * {
  flex: 1;
  height: 44px;
}
/*# sourceMappingURL=global-help-nav.component.css.map */
